export const APPRAISAL_OPEX_DEFAULTS = Object.freeze({
  leasedOrAst: '0',
  hmo: '20',
  coWork: '30',
  servicedAccommodation: '40',
})

const COMMERCIAL_USE_TYPES = new Set([
  'Retail',
  'Office',
  'Industrial',
  'Industrial / Warehouse',
  'Commercial',
  'Mixed-Use',
  'Other Commercial',
])

export function isCommercialUseType(useType) {
  return COMMERCIAL_USE_TYPES.has(useType)
}

export function isCoWorkStrategy(strategy) {
  return /co[-\s]?work|cowork|serviced office/i.test(strategyText(strategy))
}

export function isServicedAccommodationStrategy(strategy) {
  return /serviced accommodation|\bsa\b/i.test(strategyText(strategy))
}

export function commercialUnitOpexDefault({ useType, operatingModel, isCoWork = false }) {
  if (isCommercialUseType(useType)) {
    return isCoWork ? APPRAISAL_OPEX_DEFAULTS.coWork : APPRAISAL_OPEX_DEFAULTS.leasedOrAst
  }
  if (operatingModel === 'SA') return APPRAISAL_OPEX_DEFAULTS.servicedAccommodation
  if (isCoWork) return APPRAISAL_OPEX_DEFAULTS.coWork

  return APPRAISAL_OPEX_DEFAULTS.leasedOrAst
}

function strategyText(strategy) {
  return [strategy?.name, strategy?.title, strategy?.id, strategy?.key].filter(Boolean).join(' ')
}

export const CONDITIONAL_COSTS = {
  'Sales Costs (Agent + Legals)': { category: 'Legal & Structuring', defaultValue: '', confidence: 'Medium' },
  'Furniture Pack': { category: 'Operational Setup', defaultValue: '', confidence: 'Medium' },
  'HMO Licence Fees': { category: 'Legal & Structuring', defaultValue: '', confidence: 'Medium' },
  'Planning / Change of Use': { category: 'Planning & Design', defaultValue: '', confidence: 'Medium' },
  'Planning Application Fees': { category: 'Planning & Design', defaultValue: '', confidence: 'Medium' },
  'Architect / Design Team': { category: 'Planning & Design', defaultValue: '', confidence: 'Medium' },
  'Planning Consultant': { category: 'Planning & Design', defaultValue: '', confidence: 'Medium' },
  'Structural Engineer': { category: 'Planning & Design', defaultValue: '', confidence: 'Medium' },
  'Building Regulations / Compliance': { category: 'Planning & Design', defaultValue: '', confidence: 'Medium' },
  'Section 106': { category: 'Planning & Design', defaultValue: '', confidence: 'Low' },
  CIL: { category: 'Planning & Design', defaultValue: '', confidence: 'Low' },
  'Utilities Upgrade': { category: 'Operational Setup', defaultValue: '', confidence: 'Medium' },
  'Access / Highways': { category: 'Planning & Design', defaultValue: '', confidence: 'Medium' },
  'Legal Fees (Lease Creation / Title Structuring)': { category: 'Legal & Structuring', defaultValue: '', confidence: 'Medium' },
  'Planning / Planning Uplift Costs': { category: 'Planning & Design', defaultValue: '', confidence: 'Medium' },
  'Furnishing Pack': { category: 'Operational Setup', defaultValue: '', confidence: 'Medium' },
  'Interior Design / Dressing': { category: 'Operational Setup', defaultValue: '', confidence: 'Medium' },
  'Photography / Listing Setup': { category: 'Operational Setup', defaultValue: '', confidence: 'Medium' },
}

export const STRATEGY_COSTS = {
  'BRRR / Flip': ['Sales Costs (Agent + Legals)'],
  HMO: ['Furniture Pack', 'HMO Licence Fees', 'Planning / Change of Use'],
  'Commercial Conversion': [
    'Planning Application Fees',
    'Architect / Design Team',
    'Planning Consultant',
    'Structural Engineer',
    'Building Regulations / Compliance',
    'Section 106',
    'CIL',
    'Utilities Upgrade',
    'Access / Highways',
  ],
  'Commercial / Mixed-Use': [
    'Legal Fees (Lease Creation / Title Structuring)',
    'Planning / Planning Uplift Costs',
  ],
}

export const SA_COSTS = ['Furnishing Pack', 'Interior Design / Dressing', 'Photography / Listing Setup']

export const INITIAL_HMO_ROOMS = [
  { id: 1, name: 'Room 1', type: 'Double Ensuite', suggestedRent: '', adoptedRent: '' },
  { id: 2, name: 'Room 2', type: 'Double Ensuite', suggestedRent: '', adoptedRent: '' },
  { id: 3, name: 'Room 3', type: 'Double Shared Bath', suggestedRent: '', adoptedRent: '' },
  { id: 4, name: 'Room 4', type: 'Single Ensuite', suggestedRent: '', adoptedRent: '' },
]

export const INITIAL_COMMERCIAL_UNITS = [
  {
    id: 1,
    name: 'Unit 1',
    useType: 'Retail',
    sizeSqft: '1,200',
    suggestedSqftYear: '',
    adoptedSqftYear: '',
    opexPercent: APPRAISAL_OPEX_DEFAULTS.leasedOrAst,
    adoptedYield: '8.5',
    suggestedMonthlyRent: '',
    adoptedMonthlyRent: '',
    suggestedAdr: '',
    adoptedAdr: '',
    occupancy: '75',
    suggestedValue: '',
    adoptedValue: '',
    suggestedSqftValue: '',
    adoptedSqftValue: '',
    valuationBasis: 'Commercial',
    operatingModel: 'AST',
  },
  {
    id: 2,
    name: 'Unit 2',
    useType: '2-Bed Flat',
    sizeSqft: '600',
    suggestedSqftYear: '',
    adoptedSqftYear: '',
    opexPercent: APPRAISAL_OPEX_DEFAULTS.leasedOrAst,
    adoptedYield: '7',
    suggestedMonthlyRent: '',
    adoptedMonthlyRent: '',
    suggestedAdr: '',
    adoptedAdr: '',
    occupancy: '80',
    suggestedValue: '',
    adoptedValue: '',
    suggestedSqftValue: '',
    adoptedSqftValue: '',
    valuationBasis: 'Commercial',
    operatingModel: 'AST',
  },
]
